import { ForwardedRef, forwardRef } from 'react';
import { ICommonFormProps } from '../DynamicForm.types';
import { isFormValidationError } from '@src/utilities/form';
import { useCopyToClipboard } from '@src/hooks';
import { IconLabel, Input } from '@src/components/ui';
import { InputRef } from 'antd';

export const FormTextBox = forwardRef(
    (props: ICommonFormProps, ref: ForwardedRef<InputRef>) => {
        const { copyToClipboardAddOn } = useCopyToClipboard({});

        const labelText = props.label;

        const { size, ...inputProps } = props.inputProperties || {};

        return (
            <div className="w-full">
                <Input
                    className={`h-10 text-base ${props.className ?? ''}`}
                    ref={ref}
                    disabled={props.disabled || false}
                    label={labelText}
                    error={
                        props.errors
                            ? isFormValidationError(props.errors.type)
                                ? props.errors?.message
                                : `${props.label} ${props.errors.type}`
                            : undefined
                    }
                    data-component-name={props.keyName}
                    {...inputProps}
                    size={size}
                    placeholder={props.inputProperties?.placeholder || ''}
                    type={props.inputProperties?.type ?? 'text'}
                    {...props.field}
                    onChange={
                        props.formProps?.onChange
                            ? (e) => {
                                  props.formProps?.onChange(e);
                                  if (props.setValue) {
                                      props.setValue(
                                          props.keyName,
                                          e.target.value
                                      );
                                      props.triggerValidation!(props.keyName);
                                  }
                              }
                            : props.field?.onChange
                    }
                    onBlur={props.formProps?.onBlur ?? props.field?.onBlur}
                    isRequired={
                        typeof props.registerOptions?.required === 'object'
                            ? Boolean(props.registerOptions.required.value)
                            : Boolean(props.registerOptions?.required)
                    }
                    defaultValue={props.formProps?.defaultValue}
                    maxLength={props.formProps?.maxLength}
                    showCount={props.formProps?.showCount}
                    addonBefore={props.formProps?.addonBefore}
                    addonAfter={
                        props.formProps?.addonAfter ??
                        (props.formProps?.hasCopyAction &&
                            copyToClipboardAddOn(
                                props.field?.value
                                    ? props.field?.value
                                    : props.formProps?.defaultValue
                            ))
                    }
                    help={props.formProps?.help}
                />
                {props.formProps?.info && (
                    <IconLabel
                        title={props.formProps?.info}
                        type={props.formProps?.infoType}
                        rootClassName="mt-3"
                    />
                )}
            </div>
        );
    }
);

FormTextBox.displayName = 'FormTextBox';
